import React from 'react'
import { StyleSheetManager, ThemeProvider } from 'styled-components'

import { useGetThemeDirection } from '@application/Interfaces/Hooks/useGetThemeDirection/useGetThemeDirection'
import { useOrganization } from '@application/Interfaces/Hooks/useOrganization/useOrganization'
import { createMaterialUiTheme } from '@application/Interfaces/Themes/createMaterialUiTheme'
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import { getStylisPlugins } from './utils'

type Props = {
    children: React.ReactNode
}

export const LayoutProvider = ({ children }: Props): JSX.Element => {
    const organization = useOrganization()
    const direction = useGetThemeDirection()
    const theme = { ...organization.theme, direction }
    const muiTheme = createMaterialUiTheme(theme)

    return (
        <StyleSheetManager stylisPlugins={getStylisPlugins(direction)}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <MuiThemeProvider theme={muiTheme}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>{children}</LocalizationProvider>
                    </MuiThemeProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        </StyleSheetManager>
    )
}
